const initialState = {
  currentHousehold: null,
  currentHouseholdLoading: false,
  householdDetail: null,
  householdDetailError: "",
  householdDetailLoading: false,
  householdMetaError: "",
  householdMetaLoading: false,
  isRequesting: false,
  isSuccess: null,
  responseMessage: null,
};

export default function user(state = initialState, action) {
  switch (action.type) {
    case "CLIENT_CREATE_SUCCESS": {
      return {
        ...state,
        currentHousehold: action.payload.data,
      };
    }
    case "ARCHIVE_PORTFOLIO_SUCCESS": {
      const portfolioId = action.payload.data.data;
      const householdDetail = { ...state.householdDetail };
      householdDetail.Portfolios = householdDetail.Portfolios.filter(
        (portfolio) => portfolio.uuid !== portfolioId
      ).map((p) => {
        if (p.successorPortfolioId === portfolioId) {
          p.successorPortfolioId = null;
        }
        return p;
      });
      return {
        ...state,
        householdDetail,
      };
    }
    case "REMOVE_HOUSEHOLD_REQUESTED":
      return {
        ...state,
        isRequesting: true,
      };
    case "REMOVE_HOUSEHOLD_SUCCESS":
      return {
        ...state,
        isRequesting: false,
        isSuccess: true,
        responseMessage: "Success!",
      };
    case "REMOVE_HOUSEHOLD_FAIL":
      return {
        ...state,
        isRequesting: false,
        isSuccess: false,
        responseMessage: action.payload.response.data.error,
      };
    case "CLEAR_MESSAGE":
      return {
        ...state,
        isRequesting: false,
        isSuccess: null,
        responseMessage: null,
      };
    case "CLEAR_CURRENT_HOUSEHOLD":
      return {
        ...state,
        currentHousehold: null,
      };
    case "HOUSEHOLD_DETAIL_REQUESTED":
      return {
        ...state,
        householdDetailLoading: true,
        householdDetail: null,
        householdDetailError: "",
      };
    case "HOUSEHOLD_DETAIL_SUCCESS":
    case "CLIENT_UPDATE_SUCCESS":
      return {
        ...state,
        householdDetailLoading: false,
        householdDetail: action.payload.data,
        householdDetailError: "",
        currentHousehold: action.payload.data,
      };
    case "HOUSEHOLD_DETAIL_FAIL":
      return {
        ...state,
        householdDetailLoading: false,
        householdDetailError: action.payload.response.data.error,
      };
    case "HOUSEHOLD_SAVE_META_REQUESTED":
      return {
        ...state,
        currentHouseholdLoading: true,
        householdDetail: null,
      };
    case "HOUSEHOLD_SAVE_META_SUCCESS":
      return {
        ...state,
        currentHouseholdLoading: false,
        currentHousehold: {
          ...state.currentHousehold,
          ...action.payload.data,
        },
      };
    case "HOUSEHOLD_SAVE_META_FAIL":
      return {
        ...state,
        currentHouseholdLoading: false,
      };
    case "SET_PORTFOLIO_ACCOUNT_NUMBER_SUCCESS": {
      const portfolioUuid = action.payload.data.data.uuid;
      const householdDetail = { ...state.householdDetail };
      const portfolioIdx = householdDetail.Portfolios.findIndex(function (
        portfolio
      ) {
        return portfolio.uuid === portfolioUuid;
      });
      householdDetail.Portfolios.splice(
        portfolioIdx,
        1,
        action.payload.data.data
      );
      return {
        ...state,
        householdDetail,
      };
    }
    case "UPDATE_HOUSEHOLD_SETTING": {
      const currentHousehold = {
        ...state.currentHousehold,
        advisorConfig: action.payload,
      };
      return {
        ...state,
        currentHousehold,
      };
    }
    case "PORTFOLIO_FETCH_SUCCESS": {
      const currentHousehold = action.payload.data.Household;
      return {
        ...state,
        currentHousehold,
      };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/household.reducer.js